import React from "react";
import { ArrowSquareOut } from "@phosphor-icons/react";
import PageHeader from "../components/PageHeader";
import content from "../data/content.json";

export default function Boutique() {
  return (
    <div>
      <PageHeader title="Les Indispensables" subtitle="Une sélection douce pour votre post-partum" />

      <div className="mb-4 px-6">
        <div className="overflow-hidden rounded-[24px] shadow-[0_6px_24px_rgba(54,48,43,0.08)]">
          <img
            src="/fiches/indispensables.jpg"
            alt="Les Indispensables"
            data-testid="boutique-header-image"
            className="aspect-[16/9] w-full object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 px-6 sm:grid-cols-2">
        {content.products.map((p, i) => (
          <a
            key={p.id}
            href={p.link}
            target="_blank"
            rel="noopener noreferrer sponsored"
            data-testid={`product-card-${p.id}`}
            className="fade-up flex flex-col overflow-hidden rounded-3xl border border-[#36302B]/6 bg-white shadow-[0_4px_20px_rgba(54,48,43,0.03)] transition-transform hover:-translate-y-1"
            style={{ animationDelay: `${i * 40}ms` }}
          >
            <div className="aspect-square w-full overflow-hidden bg-[#FAF8F5]">
              <img
                src={`/products/${p.id}.jpg`}
                alt={p.title}
                loading="lazy"
                data-testid={`product-image-${p.id}`}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <p className="font-display text-[17px] font-medium leading-snug text-[#36302B]">{p.title}</p>
              <p className="mt-1 flex-1 text-[13.5px] leading-relaxed text-[#36302B]/65">{p.excerpt}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-[13px] font-bold text-[#C57B67]">
                Voir sur Amazon <ArrowSquareOut size={15} weight="bold" />
              </span>
            </div>
          </a>
        ))}
      </div>

      <p className="mt-6 px-6 text-center text-[12px] leading-relaxed text-[#36302B]/45">
        En tant que Partenaire Amazon, Renaître peut percevoir une commission sur les achats éligibles
        (tag : renaitre-21). Cela ne change rien au prix que vous payez.
      </p>
    </div>
  );
}

